import { z } from "zod";

export const PatientAvailableJointsResponseSchema = z.object({
  elbow: z.boolean(),
  foot: z.boolean(),
  hand: z.boolean(),
  hip: z.boolean(),
  knee: z.boolean(),
  lower_back: z.boolean(),
  lower_leg: z.boolean(),
  neck: z.boolean(),
  shoulder: z.boolean(),
  wrist: z.boolean(),
});
export type PatientAvailableJointsResponse = z.infer<typeof PatientAvailableJointsResponseSchema>;

export const GetManagerPatientsResponseSchema = z.object({
  email: z.string().nullable().optional(),
  first_name: z.string(),
  id: z.number(),
  last_name: z.string(),
  phone_number: z.string().nullable().optional(),
  preferred_name: z.string().nullable().optional(),
});

export type GetManagerPatientsResponse = z.infer<typeof GetManagerPatientsResponseSchema>;
